function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
import React from 'react';
import { picOnError } from "../../utils";
import style from "./style.module.less";
import classnames from 'classnames';
export var ProductChoose = /*#__PURE__*/function (_React$Component) {
  _inherits(ProductChoose, _React$Component);
  var _super = _createSuper(ProductChoose);
  function ProductChoose() {
    var _this;
    _classCallCheck(this, ProductChoose);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleChooseProduct", function (product) {
      _this.setState({
        product: product
      }, function () {
        _this.props.onChoose && _this.props.onChoose(product);
      });
    });
    return _this;
  }
  _createClass(ProductChoose, [{
    key: "render",
    value: function render() {
      var _Object$keys,
        _this2 = this;
      var _this$props = this.props,
        productList = _this$props.productList,
        activityDetail = _this$props.activityDetail,
        value = _this$props.value,
        groupType = _this$props.groupType;
      return /*#__PURE__*/React.createElement("div", {
        className: style['product-choose']
      }, /*#__PURE__*/React.createElement("div", {
        className: style['product-choose-activity']
      }, /*#__PURE__*/React.createElement("img", {
        src: activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.bannerUrl,
        onError: picOnError,
        className: style['product-choose-activity-img']
      }), /*#__PURE__*/React.createElement("div", {
        className: style['product-choose-product-info']
      }, /*#__PURE__*/React.createElement("div", {
        className: style['product-price']
      }, /*#__PURE__*/React.createElement("span", null, "\uFFE5"),
      // 未选商品 --> 显示活动起步价
      !value || !((_Object$keys = Object.keys(value)) !== null && _Object$keys !== void 0 && _Object$keys.length) ? /*#__PURE__*/React.createElement(React.Fragment, null, activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.price, /*#__PURE__*/React.createElement("span", null, "\u8D77")) :
      // 团长开团
      groupType === 0 ?
      // 团长优惠价
      value.specialPrice : value.price), /*#__PURE__*/React.createElement("div", {
        className: style['product-stock']
      }, value && value.initStock ? "\u4EC5\u5269".concat(value.initStock > 100 ? 100 : value.initStock) : ''), /*#__PURE__*/React.createElement("div", {
        className: style['product-select']
      }, value && value.productName ? "\u5DF2\u9009\uFF1A".concat(value.productName) : '请选择一个课程'))), /*#__PURE__*/React.createElement("div", {
        className: style['product-list']
      }, /*#__PURE__*/React.createElement("div", {
        className: style['product-list-hd']
      }, "\u9009\u62E9\u8BFE\u7A0B\uFF08", productList.length, "\uFF09"), productList.map(function (product) {
        var _classnames;
        return /*#__PURE__*/React.createElement("div", {
          className: style['product-list-item'],
          key: product.id
        }, /*#__PURE__*/React.createElement("div", {
          className: classnames((_classnames = {}, _defineProperty(_classnames, style['product-choose-item'], true), _defineProperty(_classnames, style['checked'], product.id === value.id), _classnames)),
          onClick: function onClick() {
            return _this2.handleChooseProduct(product);
          }
        }, product.productName));
      })), /*#__PURE__*/React.createElement("div", {
        className: style['product-choose-sure']
      }, this.props.children));
    }
  }]);
  return ProductChoose;
}(React.Component);
_defineProperty(ProductChoose, "defaultProps", {
  productList: [],
  activityDetail: {},
  value: null,
  onChoose: function onChoose(p) {},
  onSure: function onSure() {}
});